<template>
  <div class="mbti-qa">
    <div class="nav-bar">
      <i class="el-icon-arrow-left back-icon" @click="goBack()"></i>
      <span class="title">MBTI性格测试</span>
      <div class="capsule"></div>
    </div>

    <div v-if="questions.length === 0" class="loading">
      <p>加载题库中...</p>
    </div>
    <div v-else>
      <div class="progress-bar">
        <div class="progress-text">
          {{ currentQuestion + 1 }} / <span>{{ questions.length }}</span>
        </div>
        <div class="progress" :style="{ width: progressWidth }"></div>
      </div>
      <div class="content">
        <div class="question-card">
          <div class="question-header">
            <span class="question-number">0{{ currentQuestion + 1 }}</span>
            <span class="question-text">{{
              questions[currentQuestion] ? questions[currentQuestion].text : ""
            }}</span>
          </div>
          <div class="options">
            <div
              v-if="questions[currentQuestion]"
              class="option"
              :class="{ active: selectedOption === 'A' }"
              @click="selectOption('A')"
            >
              <div
                class="radio"
                :class="{ checked: selectedOption === 'A' }"
              ></div>
              <span class="option-text"
                >A {{ questions[currentQuestion].optionA }}</span
              >
            </div>
            <div
              v-if="questions[currentQuestion]"
              class="option"
              :class="{ active: selectedOption === 'B' }"
              @click="selectOption('B')"
            >
              <div
                class="radio"
                :class="{ checked: selectedOption === 'B' }"
              ></div>
              <span class="option-text"
                >B {{ questions[currentQuestion].optionB }}</span
              >
            </div>
          </div>
        </div>
        <div class="button-section">
          <button
            class="back-button"
            @click="prevQuestion"
            v-if="currentQuestion !== 0"
          >
            返回上一题
          </button>
          <button
            v-if="currentQuestion === questions.length - 1 && selectedOption"
            class="submit-button"
            @click="submitTest"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? "提交中..." : "提交" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWechatUserProfile } from "@/assets/js/wechatAuth";

export default {
  name: "MBTIQA",
  data() {
    return {
      currentQuestion: 0,
      selectedOption: "",
      answers: [],
      questions: [],
      originalData: [],
      isSubmitting: false, // 提交状态
    };
  },
  mounted() {
    this.fetchQuestions();
  },
  methods: {
    generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    fetchQuestions() {
      this.$get("http://59.110.51.52:8010/system/web/survey?wjId=1")
        .then((res) => {
          if (res.data && res.data.topicTianBaos) {
            this.originalData = res.data;
            // 使用UUID给name赋值
            this.originalData.name = this.generateUUID();
            this.questions = res.data.topicTianBaos.map((topic) => ({
              id: topic.tmId,
              text: topic.tmName,
              optionA: topic.optionTianBaos[0].xxName,
              optionB: topic.optionTianBaos[1].xxName,
              optionAId: topic.optionTianBaos[0].xxId,
              optionBId: topic.optionTianBaos[1].xxId,
              optionAType: topic.optionTianBaos[0].xxType,
              optionBType: topic.optionTianBaos[1].xxType,
              optionAIsOpt: topic.optionTianBaos[0].is_opt,
              optionBIsOpt: topic.optionTianBaos[1].is_opt,
            }));
          }
        })
        .catch((err) => {
          console.error("获取题库失败:", err);
        });
    },

    goBack() {
      this.$router.push("/mbti-action");
    },
    selectOption(option) {
      this.selectedOption = option;
      this.answers[this.currentQuestion] = option;

      // 如果是第一题，调用测试方法
      // if (this.currentQuestion === 0) {
      //   this.testFillAll();
      // }

      // 自动进入下一题
      if (this.currentQuestion < this.questions.length - 1) {
        setTimeout(() => {
          // 确保currentQuestion不会超出questions数组的长度范围
          if (this.currentQuestion < this.questions.length - 1) {
            this.currentQuestion++;
            this.selectedOption = this.answers[this.currentQuestion] || "";
          }
        }, 500);
      }
      // 最后一题不自动跳转，显示提交按钮
    },
    testFillAll() {
      // 测试方法：点击第一题时直接把所有题的第一项或第二项随机变为1，然后跳转到最后一题
      if (this.currentQuestion === 0) {
        // 把所有题的第一项或第二项随机变为1
        for (let i = 0; i < this.questions.length; i++) {
          this.answers[i] = Math.random() > 0.5 ? "A" : "B"; // 随机选择第一项或第二项
        }
        // 跳转到最后一题
        this.currentQuestion = this.questions.length - 1;
        this.selectedOption = Math.random() > 0.5 ? "A" : "B"; // 随机选择第一项或第二项
      }
    },
    prevQuestion() {
      if (this.currentQuestion > 0) {
        this.currentQuestion--;
        this.selectedOption = this.answers[this.currentQuestion] || "";
      }
    },
    submitTest() {
      // 避免重复提交
      if (this.isSubmitting) return;

      // 设置提交状态为true
      this.isSubmitting = true;

      const wechatUser = getWechatUserProfile();

      // 准备提交数据
      const submitData = {
        ...this.originalData,
        name: this.originalData.name || this.generateUUID(),
        topicTianBaos: this.originalData.topicTianBaos.map((topic, index) => ({
          ...topic,
          optionTianBaos: topic.optionTianBaos.map((option) => ({
            ...option,
            is_opt: this.answers[index] === option.xxXh ? 1 : 0,
          })),
        })),
        brief: wechatUser.brief || "",
        openid: wechatUser.openid || "",
        nickName: wechatUser.nickName || "",
        sex: wechatUser.sex === "" ? "" : wechatUser.sex,
        headimgurl: wechatUser.headimgurl || "",
      };

      // 存储name的uuid为本地缓存
      localStorage.setItem("mbtiTestName", submitData.name);
      // 存储wjId为本地缓存
      localStorage.setItem("mbtiTestWjId", "1");

      const openid = wechatUser.openid || "";


      // 提交数据到后台
      this.$post("http://59.110.51.52:8010/system/web/addsurvey", submitData)
        .then((res) => {
          if (res && res.code === 200) {
            this.$router.push({
              path: "/mbti-result",
              query: { openid: openid, wjId: "1" },
            });
          } else {
            console.error("提交失败:", res.message);
            this.$router.push({
              path: "/mbti-result",
              query: { openid: openid, wjId: "1" },
            });
          }
        })
        .catch((err) => {
          console.error("提交失败:", err);
          this.$router.push({
            path: "/mbti-result",
            query: { openid: openid, wjId: "1" },
          });
        })

        .finally(() => {
          // 无论成功失败，都设置提交状态为false
          this.isSubmitting = false;
        });
    },

    nextQuestion() {
      if (!this.selectedOption) return;

      if (this.currentQuestion < this.questions.length - 1) {
        this.currentQuestion++;
        this.selectedOption = this.answers[this.currentQuestion] || "";
      } else {
        // 测试完成，提交数据
        this.submitTest();
      }
    },
  },
  computed: {
    progressWidth() {
      return ((this.currentQuestion + 1) / this.questions.length) * 100 + "%";
    },
  },
};
</script>

<style scoped lang="scss">
.mbti-qa {
  min-height: 100vh;
  background: linear-gradient(to bottom, #fdd5b1, #fae5d2, #fff 70%);
  padding: 20px;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  font-size: 16px;
  color: #666;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  position: relative;
}

.back-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  margin-right: 20px;
}

.header h1 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  flex: 1;
  text-align: center;
  margin-right: 40px; /* 为了让标题居中 */
}

.progress-bar {
  position: relative;
  width: 100%;
  height: 4px;
  background: #f0f0f0;
  border-radius: 2px;
  margin-bottom: 40px;
}
.progress-text {
  position: absolute;
  top: -20px;
  right: 0;
  font-size: 14px;
  color: #ff6b00;
  span {
    color: #333;
  }
}

.progress {
  height: 100%;
  background: #ff6b00;
  border-radius: 2px;
  transition: width 0.3s ease;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.question-card {
  position: relative;
  width: 100%;
  width: 335px;
  height: 302px;
  background: url("~@/assets/images/mbti-qa-bg.png") no-repeat center center;
  background-size: 100% 100%;
  padding: 30px;
  margin-bottom: 60px;
}

.question-header {
  margin-bottom: 0px;
}

.question-number {
  font-size: 20px;
  font-weight: 700;
  color: #ff6b00;
  margin-right: 10px;
}

.question-text {
  font-size: 16px;
  color: #333;
  line-height: 1.5;
}

.options {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: absolute;
  bottom: 20px;
  width: 80%;
}

.option {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.option:hover {
  background: #f9f9f9;
}

.option.active {
  background: #fff5e6;
  border-color: #ffb800;
}

.radio {
  width: 20px;
  height: 20px;
  border: 2px solid #e0e0e0;
  border-radius: 50%;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.radio.checked {
  border-color: #ff6b00;
  background: #ff6b00;
}

.radio.checked::after {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
}

.option-text {
  font-size: 16px;
  color: #333;
  flex: 1;
  line-height: 1.2;
}

.button-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 400px;
}

.back-button,
.next-button {
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back-button {
  background: #f0f0f0;
  color: #666;
}

.back-button:hover:not(:disabled) {
  background: #e0e0e0;
}

.next-button {
  background: linear-gradient(135deg, #ffb800 0%, #ff6b00 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(255, 107, 0, 0.3);
}

.next-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 107, 0, 0.4);
}

.next-button:disabled,
.back-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.submit-button {
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #ffb800 0%, #ff6b00 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(255, 107, 0, 0.3);
}

.submit-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 107, 0, 0.4);
}

.nav-bar {
  padding: 0 !important;
  margin-bottom: 30px;
}
</style>